import { useState, useCallback } from 'react';
import type { TourStep } from '@/components/ui/product-tour';

export function useCategoriesTour() {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [hasCompletedTour, setHasCompletedTour] = useState(() => {
    return localStorage.getItem('categories-tour-completed') === 'true';
  });

  const tourSteps: TourStep[] = [
    {
      target: '[data-tour="categories-header"]',
      title: 'Welcome to Asset Categories',
      content: 'Define and organize asset categories and subcategories. Set default depreciation methods, rates, and periods for each category to streamline asset management.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="categories-search"]',
      title: 'Search Categories',
      content: 'Quickly find categories by code or description using the search bar.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="categories-new-button"]',
      title: 'Create New Category',
      content: 'Click here to add a new category. You can define depreciation defaults and create sub-categories to organize your assets.',
      placement: 'left',
    },
    {
      target: '[data-tour="categories-table"]',
      title: 'Categories List',
      content: 'View all your categories with depreciation settings and asset counts. Click the expand icon to view sub-categories. Click on a category code to view or edit its details.',
      placement: 'top',
    },
  ];

  const startTour = useCallback(() => {
    setIsTourOpen(true);
  }, []);

  const closeTour = useCallback(() => {
    setIsTourOpen(false);
  }, []);

  const completeTour = useCallback(() => {
    setIsTourOpen(false);
    setHasCompletedTour(true);
    localStorage.setItem('categories-tour-completed', 'true');
  }, []);

  const resetTour = useCallback(() => {
    setHasCompletedTour(false);
    localStorage.removeItem('categories-tour-completed');
  }, []);

  return {
    isTourOpen,
    tourSteps,
    startTour,
    closeTour,
    completeTour,
    resetTour,
    hasCompletedTour,
  };
}
